"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ykbUtils = require("ykb-utils");
var _CheckColumnType = _interopRequireDefault(require("./CheckColumnType"));
var _CheckColumnFilters = _interopRequireDefault(require("./CheckColumnFilters"));
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// hidden methods
function __deepClone(arr) {
  return arr.map(function (item) {
    return _objectSpread({}, item);
  });
}

// Tanstack tarafında kullanılan column bilgilerinin hazırlanması icin kullanılır.
function __prepareTableColumn() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var rowKey = 'dataIndex';
  return array.reduce(function (acc, item) {
    // @tanstack table tarafında header alanı zorunludur.
    var tableOptions = {
      header: item.title,
      accessorKey: item[rowKey] || 'no-data-index',
      // resizeable: true, alanlar icerisinde de kullanılacak. Sonradan eklenecek.
      size: getColumnWidth(item.width),
      maxSize: getColumnWidth(item.width),
      minSize: getColumnWidth(item.width)
    };
    if (item.autoFilter) {
      var parsedHeader = _CheckColumnFilters.default.checkColumnFilters(item, locale);
      tableOptions.filterDropdown = parsedHeader.filterDropdown;
    }
    tableOptions.sortingFn = function () {};
    if (typeof item.sorter == 'function') tableOptions.sortingFn = function (a, b) {
      return item.sorter(a.original, b.original);
    };

    //tableOptions.sortDirections = ['asc', 'desc'];
    // tekli sorting olmadıgı için default olarak asc ve desc olarak atama yapılır.
    if (
    // isNullOrUndefined(item.sortDirections) &&
    !(0, _ykbUtils.isNullOrUndefined)(item.sorter)) {
      tableOptions.sortDirections = ['asc', 'desc'];
    }

    // cell için her gerValue methodu cagrılması durumu için buraya düşer.
    tableOptions.accessorFn = function (row) {
      var key = item[rowKey];
      var value = row[key];
      return value;
    };
    if (Array.isArray(item.children) && item.children.length > 0) {
      item.children = __prepareTableColumn(locale, item.children);
    }
    var _item = Object.assign(item, tableOptions);
    acc.push(_item);
    return acc;
  }, path);
}

// Array olaraka atılan dataya, data yapısını degistirmeden
// datanın referanslarını degistirerek verilen listeye tanstack tarafında kullanılan methodların eklemesini yapar.
// Yeni bir liste olarak geriye döndürür.
function prepareTableColumn(columns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cloneArray = __deepClone(columns);
  cloneArray = __prepareExpandedColumns(cloneArray, props);
  cloneArray = __prepareColumnRowKey(cloneArray, props);
  __prepareTableColumn(props.locale, cloneArray);
  return cloneArray;
}

// rowSelection check
// row selection aktif olması durumunda ayrı bir kolon tanımaması icin
// columns değeri altında bir kolon eklenir. (listenin başına gelecek şekilde eklemesi yapılır)
var __prepareColumnRowKey = function __prepareColumnRowKey(columns, props) {
  var cloneArray = __deepClone(columns);
  var isActiveRowSelection = !(0, _ykbUtils.isNullOrUndefined)(props.rowSelection);
  if (isActiveRowSelection) {
    var _props$rowSelection, _props$rowSelection2;
    var defaultWidth = 50;
    var sizes = {
      xsmall: 30,
      small: 40
    };
    defaultWidth = sizes[props === null || props === void 0 ? void 0 : props.size] || 50;
    var column = {
      id: 'select',
      dataIndex: 'rowSelection',
      className: 'row-selection',
      header: '',
      type: 'rowSelection',
      width: (props === null || props === void 0 ? void 0 : (_props$rowSelection = props.rowSelection) === null || _props$rowSelection === void 0 ? void 0 : _props$rowSelection.width) || defaultWidth,
      fixed: (props !== null && props !== void 0 && (_props$rowSelection2 = props.rowSelection) !== null && _props$rowSelection2 !== void 0 && _props$rowSelection2.fixed ? 'left' : undefined) || undefined
    };
    cloneArray.unshift(column);
  }
  return cloneArray;
};

// expanded path değerinin yeni column altında gösterilmesi için eklendi
// expandedRowRender değeri varsa bunu yeni column altında gösterir.
// expandIconColumnIndex değerinin olduğu kısıma yeni kolon olark ekler
var __prepareExpandedColumns = function __prepareExpandedColumns(columns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cloneArray = __deepClone(columns);
  if (props.expandable && (props.expandable.expandedRowRender || props.expandable.expandIconColumnIndex)) {
    var expandIconColumnIndex = props.expandable.expandIconColumnIndex || 0;
    var isExpandedColumn = !(0, _ykbUtils.isNullOrUndefined)(props.expandable) || cloneArray.some(function (item) {
      return Array.isArray(item.children);
    });
    if (isExpandedColumn) {
      var column = {
        id: 'expandedColumn',
        header: '',
        dataIndex: 'expandedColumn',
        type: 'expandedColumn',
        className: 'row-selection'
      };
      cloneArray.splice(expandIconColumnIndex, 0, column);
    }
  }
  return cloneArray;
};

// exported methods
// DefaultEditableCell ve DefaultTableCell içerisinde kullanılan formatlama kısımlarının hazırlanması icin kullanılır.
// Kullanıcının formatlı gelmesini istedigi bir alan varsa cell altında göstermek için kullanılır.
// örn Type: 'date', format: 'DD.MM.YYYY' olması durumunda cell altında ki görüntü => 01.01.2020 şeklinde olur
function getDefaultColumnRender(locale, columnDef) {
  // checkColumnType altında render methodu hazırlanır.
  // eğer kolona ait bir render varsa kolon altına eklenir.
  // kolona ait bir render yoksa colon altına render methodu actionHandler yardımı ile eklenir.
  var parsedColumn = _CheckColumnType.default.checkColumnType(columnDef, locale);
  return parsedColumn.render;
}

// kolona gelen width değerinin hazırlanması icin kullanılır.
// string olarak gelen width değerleri number a çevrilir.
function getColumnWidth() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 150;
  var types = ['string', 'number'];
  var type = (0, _typeof2.default)(width);
  if (types.includes(type)) {
    if (type === 'string') {
      var replaceRegex = /[^0-9]/g;
      var widthNumber = Number(width.replace(replaceRegex, ''));
      return widthNumber;
    }
  }
  return width;
}

// Edit moda geçen cell bilgisi
// Tablo içlerinde default olarak kayıda ait key bilgisini döndürür.
function getRecordKeyByRowKey(record, index) {
  var rowKeyProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'key';
  var value = {
    string: record[String(rowKeyProp)],
    function: typeof rowKeyProp == 'function' && rowKeyProp(record, index)
  };
  var rowKeyType = (0, _typeof2.default)(rowKeyProp);
  return value[rowKeyType] || record.key;
}

// array olarak gelen datayi 2 parça olarak diziye böler,
// ilk parça default 11 adet obje içerir
// ikinci parca dizide geri kalan elemanların hepsini içerir.
// tablonun daha hızlı yüklnemesi için eklendi.
function arrayChunk() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var firstChunk = data.slice(0, count);
  var secondChunk = data.slice(count, data.length);
  return [(0, _toConsumableArray2.default)(firstChunk), (0, _toConsumableArray2.default)(secondChunk)];
}

// default olarak gelen sıralama verilerini tanstack kullanımı için hazırlar.
function getDefaultSorting(column) {
  var rowKey = 'dataIndex';
  return column.reduce(function (acc, item) {
    if (!(0, _ykbUtils.isNullOrUndefined)(item.defaultSortOrder)) acc.push({
      id: item[rowKey],
      desc: item.defaultSortOrder.indexOf('descend') > -1
    });
    return acc;
  }, []);
}

// kolon tipine göre seçili olan date formatı belirler.
// filterFns içerisinde kullanılır
function getDateFormat(column) {
  var TYPE_FORMAT_MAP = {
    DATE: 'DD-MM-YYYY',
    DATETIME: 'DD-MM-YYYY HH:mm:ss',
    JSONDATE: 'DD-MM-YYYY HH:mm:ss',
    TIMESTAMP: 'DD-MM-YYYY HH:mm:ss',
    TIME: 'HH:mm:ss'
  };
  var format = column.defaultBeDateformat ? column.defaultBeDateformat : TYPE_FORMAT_MAP[column.type.toUpperCase()];
  return format;
}

// kolon tipine göre secili olan filtre türünü belirler.
function getFilterType(column) {
  var isIbanSearchFilter = column.autoFilterType === 'search' || column.type === 'iban' && !column.autoFilterType;
  var isDateFilter = column.type === 'date' || column.type === 'datetime' || column.type === 'jsondate' || column.type === 'timestamp' || column.autoFilterType === 'datetime';
  var isTimeFilter = column.type === 'time' || column.autoFilterType === 'time';
  var isNumberFilter = column.type === 'number' || column.autoFilterType === 'number';
  var isCurrencyFilter = column.type === 'currency' || column.autoFilterType === 'currency';
  if (isIbanSearchFilter) {
    return 'ibanSearchFilter';
  } else if (isDateFilter) {
    return 'dateFilter';
  } else if (isTimeFilter) {
    return 'timeFilter';
  } else if (isNumberFilter) {
    return 'numberFilter';
  } else if (isCurrencyFilter) {
    return 'currencyFilter';
  } else {
    if (!(0, _ykbUtils.isNullOrUndefined)(column.filters)) return 'searchableFilter';
  }
  return 'searchableFilter';
}

// Eski tabloda dropdown filter tarafında kullanılan fonksiyonlar
function generateValueMaps(items) {
  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!(0, _ykbUtils.isNullOrUndefined)(items)) (items || []).forEach(function (_ref) {
    var value = _ref.value,
      children = _ref.children;
    maps[value.toString()] = value;
    generateValueMaps(children, maps);
  });
  return maps;
}
function splitDataIndex(column) {
  if (column.dataIndex && !Array.isArray(column.dataIndex) && column.dataIndex.includes('.')) {
    column.dataIndex = column.dataIndex.split('.');
  }
  return column;
}
function flatten(array) {
  if (Array.isArray(array)) return array.flatMap(function (_ref2) {
    var children = _ref2.children,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    return [_objectSpread({}, rest)].concat((0, _toConsumableArray2.default)(flatten(children || [])));
  });
}

// sticky cell için kullanılır
var findLastStickyWidth = function findLastStickyWidth(_ref3) {
  var index = _ref3.index,
    className = _ref3.className,
    fixedKey = _ref3.fixedKey;
  var ckRef = (0, _ykbUtils.containerChecker)(document);
  var calculatedValue = 0;
  var preparedIndex = index - 1;
  for (var i = preparedIndex; i >= 0; i--) {
    var foundedElement = ckRef.querySelector("".concat(className, "-").concat(i));
    if (!(0, _ykbUtils.isNullOrUndefined)(foundedElement) && foundedElement.className.indexOf('sticky-cell') > -1 && foundedElement.className.indexOf(fixedKey) > -1) {
      calculatedValue += foundedElement.offsetWidth;
    }
  }
  return calculatedValue;
};
var _default = exports.default = {
  getDefaultColumnRender: getDefaultColumnRender,
  getRecordKeyByRowKey: getRecordKeyByRowKey,
  prepareTableColumn: prepareTableColumn,
  arrayChunk: arrayChunk,
  splitDataIndex: splitDataIndex,
  getDefaultSorting: getDefaultSorting,
  getDateFormat: getDateFormat,
  getFilterType: getFilterType,
  findLastStickyWidth: findLastStickyWidth,
  // kaldırılabilir
  generateValueMaps: generateValueMaps,
  flatten: flatten
};